import { api } from './client';
export async function updateProfile(data) {
    return api('/api/users/me', {
        method: 'PATCH',
        body: JSON.stringify(data),
    });
}
export async function uploadAvatar(file) {
    const formData = new FormData();
    formData.append('file', file);
    return api('/api/users/avatar', {
        method: 'POST',
        body: formData,
    });
}
export async function uploadPhoto(file, order) {
    const formData = new FormData();
    formData.append('file', file);
    formData.append('order', String(order));
    return api('/api/users/photos', {
        method: 'POST',
        body: formData,
    });
}
export async function setMainPhoto(photoId) {
    return api(`/api/users/photos/${photoId}/set-main`, {
        method: 'POST',
    });
}
export async function deletePhoto(photoId) {
    return api(`/api/users/photos/${photoId}`, {
        method: 'DELETE',
    });
}
export async function getUser(id) {
    return api(`/api/users/${id}`);
}
export async function deleteAccount() {
    await api('/api/users/me', { method: 'DELETE' });
}
